import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ScrollToTop from "../components/scroll-to-top";

import hero from "../assets/images/hero/pages.jpg";
import { galleryData } from "../data/data";

export default function Gallery() {
  const [activeIndex, setActiveIndex] = useState(null);

  const activeItem = activeIndex !== null ? galleryData[activeIndex] : null;

  const handleNext = () => {
    setActiveIndex((prev) => (prev === galleryData.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? galleryData.length - 1 : prev - 1));
  };

  // ⌨️ Keyboard navigation
  useEffect(() => {
    if (activeIndex === null) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") handleNext();
      if (e.key === "ArrowLeft") handlePrev();
      if (e.key === "Escape") setActiveIndex(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex]);

  return (
    <>
      <Navbar />

      {/* HERO */}
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${hero})`,
          backgroundPosition: "center",
        }}
      >
        <div className="bg-overlay bg-gradient-overlay"></div>
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-12">
              <div className="title-heading text-center">
                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">
                  Our Gallery
                </h5>
              </div>
            </div>
          </div>

          <div className="position-middle-bottom">
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/">Tu Es Belle</Link>
                </li>
                <li className="breadcrumb-item active">Gallery</li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      {/* SHAPE */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg viewBox="0 0 2880 48" fill="none">
            <path
              d="M0 48H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* GALLERY GRID */}
      <section className="section">
        <div className="" style={{padding: '36px'}}>
          <div className="row g-4">
            {galleryData.map((item, index) => (
              <div className="col-lg-3 col-md-4 col-6" key={item.id}>
                <div
                  className="gallery-item position-relative rounded overflow-hidden shadow-sm"
                  onClick={() => setActiveIndex(index)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.type === "video" ? item.thumbnail : item.src}
                    alt={item.title}
                    className="img-fluid"
                    style={{
                      height: "220px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {item.type === "video" && (
                    <span className="position-absolute top-50 start-50 translate-middle bg-dark text-white rounded-circle px-3 py-2">
                      ▶
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MODAL PREVIEW */}
      {activeItem && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          onClick={() => setActiveIndex(null)}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div
              className="modal-content position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h5 className="modal-title">{activeItem.title}</h5>
                <button
                  className="btn-close"
                  onClick={() => setActiveIndex(null)}
                />
              </div>

              <div className="modal-body text-center position-relative">
                {/* PREV */}
                <button
                  className="btn btn-dark position-absolute top-50 start-0 translate-middle-y ms-3"
                  onClick={handlePrev}
                >
                  ❮
                </button>

                {/* CONTENT */}
                {activeItem.type === "image" ? (
                  <img
                    src={activeItem.src}
                    className="img-fluid rounded"
                    alt=""
                  />
                ) : (
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={activeItem.src}
                      title="Gallery Video"
                      allowFullScreen
                    />
                  </div>
                )}

                {/* NEXT */}
                <button
                  className="btn btn-dark position-absolute top-50 end-0 translate-middle-y me-3"
                  onClick={handleNext}
                >
                  ❯
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <ScrollToTop />
    </>
  );
}
